/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Empty_StateInputs */



/**
* | output |
* | --- |
* | "Please create a new guide to start" |
*
* @param {Style_Guide_Manager_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_empty_state = /** @type {((inputs?: Style_Guide_Manager_Empty_StateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Empty_StateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez creer un nouveau guide pour commencer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte erstellen Sie eine neue Anleitung, um zu beginnen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per favore crea una nuova guida per iniziare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, создайте новое руководство для начала.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor crea una nueva guía para comenzar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请创建新指南以开始")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始するには新しいガイドを作成してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया शुरुआत करने के लिए एक नई गाइड बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, crie um novo guia para começar.")
	return /** @type {LocalizedString} */ ("Please create a new guide to start")
});